import { render, staticRenderFns } from "./FlexibleSpaceC.vue?vue&type=template&id=34dc8182&scoped=true"
import script from "./FlexibleSpaceC.vue?vue&type=script&lang=js"
export * from "./FlexibleSpaceC.vue?vue&type=script&lang=js"
import style0 from "./FlexibleSpaceC.vue?vue&type=style&index=0&id=34dc8182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dc8182",
  null
  
)

export default component.exports